export const valInTup = [{
    half: 1.3333333333333333,
    quarter: 0.6666666666666666,
    eighth: 0.3333333333333333,
    sixteenth: 0.16666666666666666,
    thirty: 0.08333333333333333
  }, {
    quarter: 0.8,
    eighth: 0.4,
    sixteenth: 0.2,
    thirty: 0.1
  }];